export default __webpack_public_path__ + "static/media/SWT0260.34I-20117_-16356_0.5930cf37.jpg";